module.exports = __webpack_public_path__ + "img/design-preview.455c4ffe.webp";